export default {
  Required: 'إلزامي',
  'Required at least 1': 'مطلوب 1 على الأقل',
  'Impossible number': 'رقم غير ممكن',
  'Invalid number': 'رقم غير صالح',
  'Invalid email': 'بريد إلكتروني غير صالح',
  'Must contain digits only': 'يجب أن يحتوي على أرقام فقط',
  'Must be a string': 'يجب أن تكون سلسلة نصية',
  'Person must be older 18 years old': 'يجب أن يكون الشخص أكبر من 18 عامًا',
  'Must be issued at least {{days}} days ago':
    'يجب أن يكون قد تم إصداره قبل {{days}} يومًا على الأقل',
  'Must be valid for at least {{days}} days': 'يجب أن يكون صالحًا لمدة {{days}} يومًا على الأقل',
  'Must be like https://example.com': 'يجب أن يكون بمثل الرابط https://example.com',
  'Must be at least {{count}} character': 'يجب أن يكون على الأقل {{count}} حرفًا',
  'Must be at least {{count}} characters': 'يجب أن يكون على الأقل {{count}} حرفًا',
  'Max length is {{count}} character': 'الحد الأقصى للطول هو {{count}} حرف',
  'Max length is {{count}} characters': 'الحد الأقصى للطول هو {{count}} حرفًا',
  'Must be {{count}} character': 'يجب أن يكون {{count}} حرفًا',
  'Must be {{count}} characters': 'يجب أن يكون {{count}} حرفًا',
  'Min is {{minNumber}}': 'الحد الأدنى هو {{minNumber}}',
  'Max is {{maxNumber}}': 'الحد الأقصى هو {{maxNumber}}',
  'Must be more than {{num}}': 'يجب أن يكون أكثر من {{num}}',
  'Must be less than {{num}}': 'يجب أن يكون أقل من {{num}}',
  'Total shares is {{totalShares}}': 'إجمالي الأسهم هو {{totalShares}}',
  'Incorrect IBAN format': 'صيغة رقم الآيبان غير صحيحة',
  'English letters and spaces only': 'الحروف الإنجليزية والمسافات فقط',
  'IBAN must be SA followed by 22 digits': 'يجب أن يبدأ رقم الآيبان بـ SA متبوعة بـ 22 رقمًا',
  'IBAN invalid length': 'يجب أن يتكون رقم الآيبان من 24 خانة بالضبط',
  'IBAN must start with SA': 'يجب أن يبدأ رقم الآيبان بـ "SA"',
  'IBAN check digits invalid': 'يجب أن تكون خانتا التحقق (الخانتان 3 و4) أرقامًا',
  'IBAN body must be alphanumeric': 'يجب أن تكون خانات البنك والحساب (الخانات 5-24) أحرفًا أو أرقامًا',
  'IBAN checksum invalid': 'مجموع التحقق للآيبان غير صحيح — يرجى التحقق وإعادة الإدخال',
  'Enter a valid 8 or 11 character Swift Code': 'أدخل رمز سويفت صالحًا مكونًا من 8 أو 11 حرفًا',
  'Must starts with {{countryCode}}': 'يجب أن يبدأ بـ {{countryCode}}',
  'Impossible Emirates ID. Check for typos carefully':
    'رقم الهوية الوطنية غير صحيح. تحقق من الرقم بعناية',
  "Character '.' (dot) should not be first or last character":
    "لا ينبغي أن تكون النقطة ('.') الحرف الأول أو الأخير",
  "Character ' ' (space) should not be first or last character":
    "لا ينبغي أن تكون المساحة (' ') الحرف الأول أو الأخير",
  "Character '.' (dot) should not appear two or more times consecutively":
    "لا ينبغي أن تظهر النقطة ('.') مرتين أو أكثر على التوالي",
  "Character ' ' (space) should not appear two or more times consecutively":
    "لا ينبغي أن تظهر المساحة (' ') مرتين أو أكثر على التوالي",
  'Includes forbidden symbols': 'يتضمن رموزًا ممنوعة',
  'Max length is 255 characters': 'الحد الأقصى للطول هو 255 حرفًا',
  "Character ' ' (space) is forbidden": "المساحة (' ') ممنوعة",
  'Should contain only letters (A-Z) and digits (0-9)':
    'يجب أن يحتوي فقط على أحرف (A-Z) وأرقام (0-9)',
  'A-Z (hyphen) and 0-9 symbols are allowed only': 'يُسمح فقط بالرموز A-Z (واصلة) و 0-9',
  'Must be unique. Check another representative': 'يجب أن يكون فريدًا. تحقق من ممثل آخر',
  'Must be unique. Check another shareholder': 'يجب أن يكون فريدًا. تحقق من مساهم آخر',
  'Mark at least one person as an authorized signatory':
    'قم بتحديد شخص واحد على الأقل كمفوض بالتوقيع',
  'Upload Copy of Memorandum of Association or Partnership deed':
    'قم بتحميل نسخة من عقد التأسيس أو عقد الشراكة',
  'Total shares must be at least {{minShares}}%':
    'يجب أن يكون إجمالي الأسهم على الأقل {{minShares}}%',
  'Edit persons at corresponding pages': 'قم بتعديل الأشخاص في الصفحات المقابلة',
  'Must includes letters': 'يجب أن يتضمن أحرفًا',
  'Must includes only letters': 'يجب أن يتضمن أحرفًا فقط',
  'Must include only latin letters': 'يجب أن يتضمن أحرفًا لاتينية فقط',
  'Please provide authorised signatory proof and email for individual shareholder to proceed.':
    'يرجى تقديم إثبات التفويض وبريد إلكتروني للمساهم الفردي للمتابعة.',
  'Please provide Beneficial owners details to proceed.': 'يرجى تقديم تفاصيل المستفيدين للمتابعة.',
  'Only KSA banks are allowed': 'يُسمح فقط بالبنوك السعودية',
  'Please provide missing passport details for all persons who have a passport number':
    'يرجى تقديم تفاصيل جواز السفر المفقودة لجميع الأشخاص الذين لديهم رقم جواز سفر',
  'License is expired': 'انتهت صلاحية الترخيص',
  'Some mandatory data is empty. Please add the business address manually':
    'بعض البيانات الإلزامية فارغة. يرجى إضافة عنوان العمل يدويًا',
  'Latest automated screening result has an Error. Please add the screening resolution manually':
    'أحدث نتيجة فحص آلي بها خطأ. الرجاء إضافة دقة الفحص يدوياً',
  "A tax registration certificate is required based on your company's turnover value. Kindly complete the necessary data to proceed.":
    'مطلوب شهادة تسجيل ضريبي بناءً على قيمة مبيعات شركتك. يرجى استكمال البيانات اللازمة للمتابعة.',
};
